/**
 * ReportUsers entity class
 */

import moment from 'moment'

/**
 * ReportUsersFactory
 * returns ReportUsers entity class
 *
 * @class ReportUsersFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportUsers} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportUsersFactory
 */
/* @ngInject */
export default function ReportUsersFactory (Report) {
  /* === ReportSubscribers class === */

  /**
   * ReportUsers model
   *
   * @class ReportUsers
   * @classdesc ReportUsers model
   * @memberof models
   * @see models
   * @extends models.Report
   * @param {Object} [object] - initial object, containing ReportUsers entity fields
   * @return {models.ReportUsers} ReportUsers entity
   */
  function ReportUsers () {
    var obj = Report.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportUsers.prototype = Object.create(Report.prototype)
  ReportUsers.prototype.constructor = ReportUsers

  /* === User instance methods & fields === */

  Object.assign(ReportUsers.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ReportUsers#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      status: String,
      from: Date,
      to: Date,
      createdTime: moment,
      createdBy: String,
      reportType: String,
      subscriptionFromDays: Number,
      subscriptionToDays: Number,
      subscriptionFromMonth: Number,
      subscriptionToMonth: Number,
      autoPayEnabled: Boolean,
      networks: [],
      users: [],
      subscriptionIds: [],
      paymentTypes: [],
      deleted: Boolean,
      filters: {
        autoPayEnabled: Boolean,
        availableAllSubscriptions: Boolean,
        includeCustomSubscriptions: Boolean,
        networks: [],
        paymentSystemTypes: [],
        processingPeriodFrom: moment,
        processingPeriodTo: moment,
        subscriptionDaysPeriodFrom: Number,
        subscriptionDaysPeriodTo: Number,
        subscriptionMonthPeriodFrom: Number,
        subscriptionMonthPeriodTo: Number,
        subscriptions: [],
        users: []
      }
    },

    /**
     * Prepare object
     *
     * @memberof models.ReportUsers#
     * @override
     */
    _prepare () {
      // this.createdTime = moment(this.createdTime).format('MM/DD/YYYY H:m')
    },

    /**
     * url template
     *
     * @memberof models.ReportUsers#
     * @type {String}
     */
    _urlTemplate: 'api/reports/users/{{::id}}'

  })

  /* === ReportUsers static methods & fields === */

  // copy all static methods from ReportUsers class
  Object.assign(ReportUsers, Report)
  ReportUsers._name = 'ReportUsers'
  ReportUsers.init()

  // permissions
  // ReportUsers.access = {
  //   view: 'viewReport',
  //   delete: 'deleteReport'
  // }

  return ReportUsers
}
